import React from 'react';

const AppScoreBars = ({ score }) => {
    // Calculate the number of fully filled divs
    const fullDivs = Math.floor(score / 10);
    // Calculate the fractional part for partial fill (0 to 1)
    const partialFill = (score / 10) - fullDivs;
    const divs = Array(10).fill(null);
  
    return (
      <div style={{ display: 'flex', gap: '2px', width: '100%', marginTop: '.5rem' }}>
        {divs.map((_, index) => {
          let background;
          if (index < fullDivs) {
            // Fully filled divs
            background = 'rgba(160, 160, 160, 0.5)'; // Light gray transparent
          } else if (index === fullDivs && partialFill > 0) {
            // Partially filled div
            background = `linear-gradient(to right, rgba(160, 160, 160, 0.5) ${partialFill * 100}%, rgba(64, 64, 64, 0.5) ${partialFill * 100}%)`;
          } else {
            // Empty divs
            background = 'rgba(64, 64, 64, 0.5)'; // Dark gray transparent
          }
  
          return (
            <div
              key={index}
              style={{
                width: '10%',
                height: '3px',
                background: background,
                borderRadius: '4px'
              }}
            />
          );
        })}
      </div>
    );
};
  
export default AppScoreBars;